import DatePicker from 'react-datepicker';
import 'components/common/calendar/style/react-datepicker.css';
import { ko } from 'date-fns/locale';
import CommonCalendarHeader, {
  CalendarHeaderProps,
} from 'components/common/calendar/common/header/CommonCalendarHeader';

type Props = {
  startDate: Date;
  calendarDays?: Date[] | [];
  handleAddClosedDay: (date: Date) => void;
  handleMonthChange: (date: Date) => void;
};

const Calendar = ({ startDate, calendarDays, handleAddClosedDay, handleMonthChange }: Props) => {
  const renderHeader = ({ decreaseMonth, increaseMonth, date }: CalendarHeaderProps) => (
    <CommonCalendarHeader decreaseMonth={decreaseMonth} increaseMonth={increaseMonth} date={date} />
  );

  return (
    <div className='w-[360px]'>
      <DatePicker
        dateFormat='yyyy/MM/dd'
        locale={ko}
        renderCustomHeader={renderHeader}
        startDate={startDate}
        onChange={handleAddClosedDay}
        inline // 캘린더 오픈
        shouldCloseOnSelect={false} // 클릭해도 안 사라짐
        highlightDates={calendarDays && [...calendarDays]}
        onMonthChange={handleMonthChange}
        // dayClassName={d =>
        //   getDate(d) === getDate(startDate) && getMonth(d) === getMonth(startDate)
        //     ? 'normal-day selected-day'
        //     : 'normal-day'
        // }
      />
    </div>
  );
};

export default Calendar;
